import * as z from "zod/v4";
import { TrackerSchema } from "@redotech/redo-model/order-schema";
import { disputeEvidenceSchema_ } from "@redotech/redo-dispute-db-schema/dispute-evidence-definition";
import {
  disputeSchema_,
} from "@redotech/redo-dispute-db-schema/dispute-definition";

const fulfillmentTrackerSchema_ = z.object({
  _tracker: TrackerSchema,
  fulfillmentID: z.string().nullish(),
  locationId: z.string().nullish(),
});
export const fulfillmentTrackerSchema: z.ZodType<DisputeFulfillmentTracker> =
  fulfillmentTrackerSchema_;
export interface DisputeFulfillmentTracker
  extends z.infer<typeof fulfillmentTrackerSchema_> {}

const disputeViewSchema_ = disputeSchema_.extend({
  orderName: z.string().nullish(),
  customerName: z.string().nullish(),
  evidence: disputeEvidenceSchema_.nullish(),
  trackers: z.array(fulfillmentTrackerSchema_).nullish(),
  orderTrackingEnabled: z.boolean().nullish(),
  orderId: z.string().nullish(),
});

export const disputeViewSchema: z.ZodType<DisputeView> = disputeViewSchema_;
export interface DisputeView extends z.infer<typeof disputeViewSchema_> {}
